// extracted by mini-css-extract-plugin
export default {"container":"_f1c2e802","messageContainer":"_3a164109"};